import * as React from 'react';

export default function FinanceVisual(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={70} height={70} viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M44.577 50.722H1.58V17.25h55.78v17.112"
        stroke="var(--cds-color-grey-700)"
        strokeWidth={3}
        strokeLinejoin="round"
      />
      <path
        d="M6.576 17.05V11h56.867v25.751"
        stroke="var(--cds-color-grey-700)"
        strokeWidth={3}
        strokeLinejoin="round"
      />
      <path
        d="M1.831 42.65a8.356 8.356 0 018.355 8.356M10.203 18.05a8.355 8.355 0 01-8.355 8.356M57.527 26.406a8.355 8.355 0 01-8.355-8.355M29.755 42.918a8.205 8.205 0 100-16.41 8.205 8.205 0 000 16.41z"
        stroke="var(--cds-color-grey-700)"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M56.876 34.244a11.881 11.881 0 11-.835 0h.835z"
        stroke="var(--cds-color-grey-700)"
        strokeWidth={3}
        strokeLinejoin="round"
      />
      <path
        d="M59.399 40.393a6.182 6.182 0 00-3.108-1.002 3.342 3.342 0 00-3.342 2.907c0 1.521 1.086 2.741 3.342 3.71 2.557 1.086 3.342 2.039 3.342 3.693a3.576 3.576 0 01-3.86 3.209 5.965 5.965 0 01-3.342-1.053M57.077 37.068l-2.072 18.148"
        stroke="var(--cds-color-grey-700)"
        strokeWidth={2}
        strokeLinejoin="round"
      />
    </svg>
  );
}
